export const reloadComponentWithSuccess = () => {
    if (window.location.href.indexOf('success=true') == -1) {
        window.location.href = window.location.href + "?success=true";
    } else {
        window.location.reload(true);
    }
};

